import { QuizScene, QuizHandler } from "../../lib/quiz/Quiz";
import QuizQuestion from "../QuizQuestion/QuizQuestion";

interface Props {
  quizHandler: QuizHandler;
  quizScene: QuizScene;
  showAnswer: boolean;
}

export default function QuizeQuestions({
  quizHandler,
  quizScene,
  showAnswer,
}: Props) {
  const questionIndices = quizHandler.getCurrentQuestionIndices();

  return (
    <div className="quizzes">
      {questionIndices.map((questionIndex, position) => (
        <QuizQuestion
          key={questionIndex}
          quizHandler={quizHandler}
          position={position}
          questionIndex={questionIndex}
          showAnswer={showAnswer}
        ></QuizQuestion>
      ))}
    </div>
  );
}
